import { render } from "./AlarmsTable.vue?vue&type=template&id=03e2921b&scoped=true"
import script from "./AlarmsTable.vue?vue&type=script&lang=js"
export * from "./AlarmsTable.vue?vue&type=script&lang=js"

import "./AlarmsTable.vue?vue&type=style&index=0&id=03e2921b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e2921b"]])

export default __exports__